export default __webpack_public_path__ + "static/media/NewBillEditoff.fab0a683.svg";